module.exports = __webpack_public_path__ + "static/media/email.2dcdbbc7.svg";